const documentBody = document.querySelector('body');
const config = { attributes: true };

const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class' 
        && mutation.target.classList.contains('snize-instant-widget-is-open')) {

            const snizeInput = document.querySelector('#snize-mobile-search-input');
            if (snizeInput) {
                snizeInput.placeholder = 'Search WSS';
            }

            const snizeContent = document.querySelector('.snize-ac-results-content');
            snizeContent.addEventListener('click', (event) => {
                const snizeResultsMobile = document.querySelector('.snize-ac-results-mobile');
                if (event.target.id !== 'snize-mobile-search-input') {
                    snizeResultsMobile.style.display = 'none';
                }
            });
        }
    }
};

const observer = new MutationObserver(callback);
observer.observe(documentBody, config);